import { useState } from "react";
import styles from "./BetTableRace17.module.css";
import { FaInfoCircle } from "react-icons/fa";
import { MdLock } from "react-icons/md";

const PlayerOption = ({ player, back, lay, backStake, layStake, onClick, betData, exposures = {}, myBets = [] }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    
    const gstatus = betData?.gstatus;
    const isSuspended = gstatus?.toUpperCase() === "SUSPENDED";
    const min = betData?.min || 100;
    const max = betData?.max || 500000;
    const maxDisplay = max >= 1000 ? `${(max / 1000).toFixed(0)}K` : max;

    // Get exposure value for this player
    const getExposure = (playerName) => {
        const exposureKeys = [
            playerName,
            playerName?.toLowerCase(),
        ];

        for (const key of exposureKeys) {
            if (exposures[key] !== undefined) {
                return exposures[key];
            }
        }
        return 0;
    };

    // Check if there's a bet placed for this player and bet type
    const hasBackBet = myBets.some(bet => {
        const betSelection = (bet.matchedBet || bet.selection || bet.player_name || "").toLowerCase();
        const playerName = player?.toLowerCase() || "";
        return betSelection.includes(playerName) && bet.type === "back";
    });

    const hasLayBet = myBets.some(bet => {
        const betSelection = (bet.matchedBet || bet.selection || bet.player_name || "").toLowerCase();
        const playerName = player?.toLowerCase() || "";
        return betSelection.includes(playerName) && bet.type === "lay";
    });

    // Only show exposure in the cell where the bet was placed
    const totalExposure = getExposure(player);
    const backExposure = hasBackBet ? totalExposure : 0;
    const layExposure = hasLayBet ? totalExposure : 0;

    const renderBetBox = (value, stake, type) => {
        const isLocked = value === 0 || value === undefined;
        const exposure = type === "back" ? backExposure : layExposure;
        const showExposure = exposure !== 0 && (type === "back" ? hasBackBet : hasLayBet);

        return (
            <div
                className={`${styles.betBox} ${styles[type]} ${isLocked ? styles.locked : ""}`}
                onClick={() => !isLocked && !isSuspended && onClick(value, player, type, betData)}
            >
                {isLocked ? (
                    <MdLock color="white" />
                ) : (
                    <div className={styles.cellContent}>
                        <div className={styles.odds}>{value}</div>
                        <div className={styles.stake}>{stake || 0}</div>
                        {showExposure && (
                            <div className={styles.exposure} style={{
                                color: exposure < 0 ? '#ff0000' : '#00ff00',
                            }}>
                                {exposure < 0 ? exposure.toFixed(2) : `+${exposure.toFixed(2)}`}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={styles.playerOption}>
            <div className={styles.header}>
                <span className={styles.label}>{player}</span>
                <div 
                    className={styles.infoIcon}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <FaInfoCircle />
                    {showTooltip && (
                        <div className={styles.tooltip}>
                            Range: <span>{min}</span> - <span>{maxDisplay}</span>
                        </div>
                    )}
                </div>
            </div>
            {isSuspended ? (
                <div className={styles.suspendedBox}>
                    <div className={styles.suspendedText}>SUSPENDED</div>
                </div>
            ) : (
                <div className={styles.betOptions}>
                    {renderBetBox(back, backStake, "back")}
                    {renderBetBox(lay, layStake, "lay")}
                </div>
            )}
            <div className={styles.bookCount}>0</div>
        </div>
    );
};

export default function BetTableRace17({ data = [], playersData = [], onBetClick, exposures = {}, myBets = [] }) {
    const isDataAvailable = data && data.length > 0;
    const fallbackData = [
        {
            player: "Race to 17",
            back: undefined,
            lay: undefined,
            backStake: undefined,
            layStake: undefined,
        },
        {
            player: "Big Card (7,8,9) - 1",
            back: undefined,
            lay: undefined,
            backStake: undefined,
            layStake: undefined,
        },
        {
            player: "Zero Card - 1",
            back: undefined,
            lay: undefined,
            backStake: undefined,
            layStake: undefined,
        },
        {
            player: "Any Zero",
            back: undefined,
            lay: undefined,
            backStake: undefined,
            layStake: undefined,
        },
    ];

    const displayData = isDataAvailable ? data : fallbackData;

    return (
        <div className={styles.betTable}>
            {displayData.map((playerData, index) => {
                const betDataItem = playersData[index] || null;
                return (
                    <PlayerOption
                        key={index}
                        player={playerData.player}
                        back={playerData.back}
                        lay={playerData.lay}
                        backStake={playerData.backStake || betDataItem?.bs}
                        layStake={playerData.layStake || betDataItem?.ls}
                        onClick={onBetClick}
                        betData={betDataItem}
                        exposures={exposures}
                        myBets={myBets}
                    />
                );
            })}
        </div>
    );
}
